import React from "react";
import { TEAM } from "../data/mock";

export default function Team() {
  return (
    <section id="team" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 reveal">
          <div>
            <div className="text-xs font-bold tracking-[0.22em] uppercase text-[#f59e0b]">_team</div>
            <h2 className="mt-3 text-3xl md:text-5xl font-extrabold text-[#0a1f55] leading-[1.05]">
              Un team di professionisti<br className="hidden md:block" /> al servizio della tua formazione
            </h2>
          </div>
          <p className="max-w-md text-slate-600">
            Esperti di formazione, tecnologia e sostenibilità lavorano insieme per costruire
            percorsi concreti e di valore per i soci ACDT.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-5">
          {TEAM.map((m, i) => (
            <div
              key={m.name}
              className="reveal group relative rounded-2xl border border-slate-200 bg-white p-4 lift overflow-hidden"
              style={{ transitionDelay: `${i * 60}ms` }}
            >
              <div className="relative h-48 w-full rounded-xl overflow-hidden bg-gradient-to-br from-[#102a6b] to-[#1e40af]">
                <img
                  src={m.photo}
                  alt={m.name}
                  loading="lazy"
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  onError={(e) => { e.currentTarget.style.display = "none"; }}
                />
                <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-black/55 to-transparent"></div>
              </div>
              <div className="mt-3.5 text-center">
                <h3 className="text-[15px] font-bold text-[#0a1f55] leading-tight">{m.name}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
